import request from '../utils/request';

export const getFeeds = async (take: number): Promise<any> =>
    await request.get(`/feeds?take=${take}`);
